module.exports = __webpack_public_path__ + "static/img/m_role.af254e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/oo/m_role.png
// module id = q2kD
// module chunks = 7